import LegalDocumentPage from "./LegalDocumentPage";
import { helpSupportDocument } from "./legalDocumentContent";

const HelpSupport = () => {
  return <LegalDocumentPage document={helpSupportDocument} />;
};

export default HelpSupport;